module.exports = __webpack_public_path__ + "static/media/mic_1.881b00ff.jpg";